import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/_services/admin.service';

@Component({
  selector: 'app-task-template-list',
  templateUrl: './task-template-list.component.html',
  styleUrls: ['./task-template-list.component.css']
})
export class TaskTemplateListComponent implements OnInit {

 taskTemplates =[]
 filterText="STANDARD"
 syllabuscode=""
   dtOptions: DataTables.Settings = {};

   constructor(
     private adminService:AdminService,
     private activatedRoute:ActivatedRoute

   ) { }

   ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
    this.activatedRoute.params.subscribe(
      params=>{
        this.filterText = params['searchText']
        this.syllabuscode = params['syllabuscode']

        this.adminService.getTaskTemplatesByFilter(this.filterText, this.syllabuscode).subscribe(
          x=>{
            this.taskTemplates=[{},...x]
          }
        )
      }

    )



   }

 }

